<template>
    <div class="row dl-data" :class="{'hovered': editForm}">
        <div class="col-md-6">
            <p class="field">{{ title }}</p>
            <p class="value" :class="{'approved': this.approved}">{{ mvalue ? mvalue : '---' }}</p>
        </div>
        <div class="col-md-6 text-right">
            <div class="actions">
                <div v-if="!this.approved">
                    <i class="fa mr-3" :class="{'fa-pencil': !editForm, 'fa-times': editForm}" @click="edit"></i>
                    <i class="fa fa-check" @click="approve"></i>
                </div>
                <div v-else>
                    <i class="fa fa-times" @click="disapprove"></i>
                </div>
            </div>
        </div>
        <div class="container" v-if="editForm">
            <div class="row">
                <div class="col-md-6">
                    <input class="form-control" type="text" v-model="mvalue" v-if="type === 'text'"/>
                    <input class="form-control" type="date" v-model="mvalue" v-if="type === 'date'"/>
                    <select class="form-control" v-if="type === 'select'" v-model="mvalue">
                        <option value="">Select...</option>
                        <option v-for="(option, key) in options" :value="key" :key="key">{{ option }}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <button class="btn btn-success" @click="changeVal">Change</button>
                </div>
            </div>
        </div>
        <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ error }}</div>
    </div>
</template>

<script>
    import {ServerErrors} from "@/mixins/ServerErrors";
    import Swal from "sweetalert2";

    export default {
        props: [
            'field',
            'value',
            'title',
            'approved',
            'id',
            'options',
            'type'
        ],
        data () {
            return {
                errors: [],
                editForm: false,
                mvalue: this.value
            }
        },
        mixins: [ServerErrors],
        methods: {
            edit() {
                this.editForm  = !this.editForm;
            },
            approve() {
                let data = {'field': this.field, 'value': this.mvalue, 'title': this.title};
                if (!this.mvalue) {
                    data.isEdit = true;
                }
                this.change('Approved', data);
            },
            disapprove() {
                this.change('Disapproved', {'field': this.field, 'title': this.title});
            },
            changeVal() {
                this.change('Approved', {'field': this.field, 'value': this.mvalue, 'isEdit': this.editForm, 'title': this.title});
            },
            change(successTitle, data) {
                let loader = this.$loading.show();
                this.errors = [];
                window.axios({
                    method: 'POST',
                    url: '/admin/driver/' + this.id + '/approve-field',
                    data: data
                })
                    .then(() => {
                        this.approved = !this.approved;
                        Swal.fire({
                            icon: 'success',
                            title: successTitle
                        });
                        this.editForm = false;
                    })
                    .catch(error => {
                        this.errors = this.server_errors;
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: error.response.data.title ? error.response.data.title: "Something went wrong."
                        });
                    })
                    .finally(() => {
                        loader.hide();
                    });
            }
        },
        mounted() {
        }
    }
</script>